export default {
  paymentProofNumber: 'מספר אסמכתא',
  paymentDate: 'תאריך הפקדה',
  value: 'סכום',
  associatedAgents: 'סוכנים',
  comments: 'הערות',
  uploadFiles: 'העלאת קבצים',
  title: 'עריכת אסמכתא',
  notification: {
    success: {
      title: 'הפרטים עודכנו בהצלחה',
    },
    failure: {
      title: 'הפרטים לא עדכנו',
    },
  },
};
